(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('HubFlyersService', HubFlyersService);

    HubFlyersService.$inject = ['HubFlyersFactory', '$localStorage', 'Upload', 'uploadFileConstants'];

    function HubFlyersService(HubFlyersFactory, $localStorage, Upload, uploadFileConstants) {

        var service = {
            createFlyer: createFlyer,
            saveFlyerImage: saveFlyerImage,
			saveFlyerMultiImage: saveFlyerMultiImage,
            deleteFlyers: deleteFlyers,
            listFlyers: listFlyers,
            listFlyersPage: listFlyersPage,
            listFlyersFiltered: listFlyersFiltered,
            updateFlyer: updateFlyer,
            getFlyer: getFlyer,
            getNumberOfFlyers: getNumberOfFlyers,
            getFlyerTypes: getFlyerTypes,
            listAllFlyers: listAllFlyers,
            getImageFlyer: getImageFlyer,
            getLinkImageFlyerAsString: getLinkImageFlyerAsString,
            listAllToAdmin: listAllToAdmin,
            listFlyersPageToModal: listFlyersPageToModal,
            flyersImportStatus: flyersImportStatus,
            listAllFlyersByHub: listAllFlyersByHub,
            listAllFlyersByBrand: listAllFlyersByBrand,
            importFlyersFromVtex: importFlyersFromVtex,
            uploadFile: uploadFile,
            uploadVideo: uploadVideo,
            findBrands: findBrands,
            findAllBrands: findAllBrands,
            listCategoryFilterOptions: listCategoryFilterOptions,
            listBrandFilterOptions: listBrandFilterOptions,
            listColorFilterOptions: listColorFilterOptions,
            listSizeFilterOptions: listSizeFilterOptions,
            listImportHubFlyersStatus: listImportHubFlyersStatus
        };

        return service;

        function createFlyer(flyer) {
            return HubFlyersFactory.save(flyer).$promise;
        }

        function listFlyers(pageable, filter, onSuccess, onError) {
            return HubFlyersFactory.listAll(pageable, filter, onSuccess, onError);
        }

        function listAllToAdmin(pageable, filter, onSuccess, onError) {
            return HubFlyersFactory.listAllToAdmin(pageable, filter, onSuccess, onError);
        }

        function listFlyersPage(pageable, filter, onSuccess, onError) {
            return HubFlyersFactory.listAllPageable(pageable, filter, onSuccess, onError);
        }

        function listFlyersFiltered(pageable, filter, onSuccess, onError) {
            return HubFlyersFactory.listAllFiltered(pageable, filter, onSuccess, onError);
        }

        function listFlyersPageToModal(pageable) {
            return HubFlyersFactory.listAllPageableToModal(pageable, { storeId: $localStorage.defaultStore.storeId }).$promise;
        }

        function deleteFlyers(flyerIds) {
            return HubFlyersFactory.deletebyids({flyerIds: flyerIds}).$promise;
        }

        function getFlyer(flyer) {
            return HubFlyersFactory.get({flyerId: flyer, storeId: $localStorage.defaultStore.storeId}).$promise;
        }

        function updateFlyer(flyer) {
            return HubFlyersFactory.update(flyer).$promise;
        }

        function saveFlyerImage(image) {
            return Upload.upload({url: 'zuul/flyer/api/upload', data: {file: image}});
        }

        function saveFlyerMultiImage(image, orderNumber) {
            return Upload.upload({url: 'zuul/flyer/api/multiUpload', data: {file: image, orderNumber: orderNumber}});
        }

        function uploadFile(file, uploadType) {
            return Upload.upload({
                url: "/flyer/api/upload/file",
                contentType: "multipart/form-data",
                data: {
                    destination: uploadFileConstants.ASSET_FILE_DESTINATION.HUB_FLYER,
                    file: file,
                    uploadType: uploadType
                },
            });
        }

        function uploadVideo(video, uploadType) {
            return Upload.upload({
                url: "/flyer/api/upload/file",
                data: {
                    destination: uploadFileConstants.ASSET_FILE_DESTINATION.HUB_FLYER,
                    file: video,
                    uploadType: uploadType
                },
            });
        }

        function getNumberOfFlyers(storeId) {
            return HubFlyersFactory.numberOfFlyers({storeId: storeId}).$promise;
        }

        function getFlyerTypes(storeId) {
            return HubFlyersFactory.getFlyerTypes().$promise;
		}

        function listAllFlyers() {
            return HubFlyersFactory.listAllFlyers().$promise;
        }

        function getImageFlyer(flyerId) {
            return HubFlyersFactory.flyerImage({id: flyerId}).$promise;
        }

        function getLinkImageFlyerAsString(flyerId) {
            return HubFlyersFactory.flyerLinkImageAsString({id: flyerId}).$promise;
        }

        function flyersImportStatus(importId) {
            return HubFlyersFactory.flyersImportStatus({id: $localStorage.hub.id, importId: importId}).$promise;
        }

        function listAllFlyersByHub() {
            return HubFlyersFactory.listAllFlyersByHub().$promise;
        }

        function listAllFlyersByBrand(brand) {
            return HubFlyersFactory.listAllFlyersByBrand({brand: brand}).$promise;
        }

        function importFlyersFromVtex(hub) {
            var param = {
                hub: hub
            }
            return HubFlyersFactory.importFlyersFromVtex(param).$promise;
        }

        function findBrands(pageable, filter, onSuccess, onError) {
            HubFlyersFactory.findFlyerBrands(pageable, filter, onSuccess, onError);
        }

        function findAllBrands(filter, onSuccess, onError) {
            HubFlyersFactory.findAllFlyerBrands(filter, onSuccess, onError);
        }

        function listCategoryFilterOptions(pageable, search, onSuccess, onError) {
            return HubFlyersFactory.listCategoryFilterOptions(
                {
                    page: pageable.page,
                    size: pageable.size,
                    search: search,
                    inUse: false // Retornar apenas categorias que estão em uso?
                }, onSuccess, onError);
        }

        function listBrandFilterOptions(pageable, search, onSuccess, onError) {
            return HubFlyersFactory.listBrandFilterOptions(
                {
                    page: pageable.page,
                    size: pageable.size,
                    search: search,
                    inUse: false // Retornar apenas marcas que estão em uso?
                }, onSuccess, onError);
        }

        function listColorFilterOptions(pageable, search, onSuccess, onError) {
            return HubFlyersFactory.listColorFilterOptions(
                {
                    page: pageable.page,
                    size: pageable.size,
                    search: search,
                    inUse: false // Retornar apenas cores que estão em uso?
                }, onSuccess, onError);
        }

        function listSizeFilterOptions(pageable, search, onSuccess, onError) {
            return HubFlyersFactory.listSizeFilterOptions(
                {
                    page: pageable.page,
                    size: pageable.size,
                    search: search,
                    inUse: true // Retornar apenas tamanhos que estão em uso?
                }, onSuccess, onError);
        }

        function listImportHubFlyersStatus(page, size, sort) {
            var params = {
                page: page || 0,
                size: size || 3,
                sort: sort || 'createdDate,desc'
            };

            return HubFlyersFactory.listImportHubFlyersStatus(params).$promise;
        }
    }

})();
